<template>
    <div class="main-content bg-default">
        <!-- Navbar -->
        <base-nav class="navbar-top navbar-horizontal navbar-dark"
                  containerClasses="px-4 container"
                  expand>
            <router-link slot="brand" class="navbar-brand" to="/">
                <img src="img/brand/aidc-ns_horizontal.png" 
                style="    width:25%; height: auto;"/>
            </router-link>

            <template v-slot="{closeMenu}">
                <!-- Collapse header -->
                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img src="img/brand/aidc-ns_horizontal.png">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <button type="button"
                                    @click="closeMenu"
                                    class="navbar-toggler"
                                    aria-label="Toggle sidenav">
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Navbar items -->
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/login">
                            <i class="ni ni-circle-08"></i>
                            <span class="nav-link-inner--text">Registrar</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/login" >
                            <i class="ni ni-key-25" ></i>
                            <span class="nav-link-inner--text">Iniciar sesión</span>
                        </router-link>
                    </li>
                </ul>
            </template>
        </base-nav>
        <!-- Header -->
        <div class="header pt-lg-8 pb-lg-1" style="background-image: url('img/ph/hi.jpg');background-repeat: no-repeat;background-size: cover;">
            <div class="container">
                <div class="header-body text-center mb-3">
                    <div class="row justify-content-center pt-4 pb-1">
                        <div class="col-lg-5 col-md-6">
                            <h1 class="text-white strokeme text-center">Bienvenido!</h1>
                            <p class="text-lead text-white strokeme font-weight-bold">La aplicacion web de AIDC CLICK le 
                                permitira crear proyectos viales desde la memoria descriptiva a los diseños finales.</p>
                        </div>
                    </div>
                    <div class="pb-2">
                        <img src="img/ph/memoria.jpg" class="img-fluid" alt="Responsive image" style="width: 50%">
                    </div>
                </div>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--1 pb-5">
            <slide-y-up-transition mode="out-in" origin="center top">
                <router-view></router-view>
            </slide-y-up-transition>
        </div>
        <footer class="py-5">
            <div class="container">
                <div class="row align-items-center justify-content-xl-between">
                    <div class="col-xl-6">
                        <div class="copyright text-center text-xl-left text-muted">
                            &copy; {{year}} <a href="http://www.aidcingenieros.com/" class="font-weight-bold ml-1"
                                               target="_blank">AIDC Ingenieros Consultores S.A.C.</a>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <ul class="nav nav-footer justify-content-center justify-content-xl-end">
                            <li class="nav-item">
                                <a href="https://aidcns.com/index.php?option=com_content&task=view&id=9&Itemid=22" class="nav-link" target="_blank">AIDCNS</a>
                            </li>
                            <li class="nav-item">
                                <a href="https://www.facebook.com/AIDC-Ingenieros-Consultores-239873949431445/" class="nav-link" target="_blank">Facebook</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
  import { SlideYUpTransition } from 'vue2-transitions'

  export default {
    name: 'auth-layout',
    components: {
      SlideYUpTransition
    },
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false
      }
    }
  }
</script>
<style>
.strokeme {
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

</style>
